import { Left } from 'Models/Menu/menus';
import { getView, requireAuth } from '@/lib/utils';
import { UsersPage } from '@/data/appInformationItems';

export default {
  path: '/users',
  name: 'users',
  component: getView('pages/PageUsers'),
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'Users',
    leftMenu: Left.UsersList,
    roles: ['operator'],
    information: UsersPage,
    showBottomMenu: true,
  },
};
